module.exports = __webpack_public_path__ + "media/images/wintak_mil_white_cord-6a04171c58245fd61d68711ba3746000.png";